export const detectPaymentSystem = (cardNumber: string): string => {
    const cleanedNumber = cardNumber.replace(/\s/g, '')
    const firstDigit = cleanedNumber[0]
    const firstTwoDigits = cleanedNumber.substring(0, 2)
    const firstFourDigits = cleanedNumber.substring(0, 4)

    if (firstDigit === '2') {
        return 'МИР'
    }

    if (firstDigit === '4') {
        return 'VISA'
    }

    if (
        (parseInt(firstTwoDigits) >= 51 && parseInt(firstTwoDigits) <= 55) ||
        (parseInt(firstFourDigits) >= 2221 && parseInt(firstFourDigits) <= 2720)
    ) {
        return 'Mastercard'
    }

    return 'Неизвестно'
}

